import { findProductIndexInProducts } from "./findProductIndexInProducts";
import { UNIQUE_FIELDS } from "../../store/modules/cart";

export const countProducts = products =>
  products.reduce((prev, curr) => {
    const prevIndex = findProductIndexInProducts(curr, prev, UNIQUE_FIELDS);
    if (prevIndex > -1) {
      var existing = prev.splice(prevIndex, 1)[0];
      existing.count += 1;
      return [...prev, existing];
    } else {
      curr.count = 1;
      return [...prev, curr];
    }
  }, []);
